var map = {
	"./Ic_checklist_v2.svg": "gBSL",
	"./activeDot.svg": "ydbj",
	"./choose-survey-mobile.svg": "Eq4s",
	"./chose-survey.svg": "adZI",
	"./disableDot.svg": "tLZ6",
	"./fonts/proximanova-light-webfont.svg": "8NvL",
	"./fonts/proximanova-regular-webfont.svg": "u6eI",
	"./fonts/proximanova-regularit-webfont.svg": "33FP",
	"./fonts/proximanova-semibold-webfont.svg": "U+1z",
	"./ic_arrow.svg": "a1QY",
	"./ic_attachment.svg": "S5Vx",
	"./ic_back_arrow.svg": "pYU4",
	"./ic_bin_gray.svg": "kejY",
	"./ic_bin_green.svg": "8b7E",
	"./ic_bin_red.svg": "jHZ0",
	"./ic_checkmark_gray.svg": "AwsK",
	"./ic_checkmark_green.svg": "LpvF",
	"./ic_chevron_down.svg": "WBpU",
	"./ic_chevron_up.svg": "MUeO",
	"./ic_close.svg": "j5SN",
	"./ic_entry_completed.svg": "v/Kp",
	"./ic_entry_incompleted.svg": "xmJJ",
	"./ic_pen_gray.svg": "Jbkw",
	"./ic_pen_green.svg": "eren",
	"./ic_print.svg": "NzN3",
	"./ic_profile.svg": "rnLd",
	"./ic_przebieg_terapi.svg": "02eG",
	"./ic_rozpoznania.svg": "BNQz",
	"./ic_wywiad.svg": "u0uC",
	"./ic_zalecenia.svg": "H26T",
	"./navbar mobile dark.svg": "Gm0Y",
	"./navbar_mobile.svg": "Sz3N",
	"./skeleton.svg": "5YsF",
	"./survey.svg": "jhns",
	"./touchedDot.svg": "yW7Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B4Oj";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.svg$
// module id = B4Oj
// module chunks = 1